/**
 * options: {
 *     reset(boolean): reset the tree selector each time the popup is opened,
 *     createTree(function):
 *         @arg container node
 *         @return the flat tree instance to use
 * }
 */
define('commons/flat-tree-popup',['jquery', 'jquery.ui'], function($, FlatTree) {
    
    var FlatTreePopup = function(triggerSelector, popupOptions, options) {
        
        // Create the selection popup
        this.dialogSelector = $('<div></div>').appendTo('body').dialog($.extend(true, {
            'autoOpen': false,
            'resizable': false,
            'draggable': true,
            'height': 500,
            'width': '50%',
            'modal': true,
            'zIndex': 100,
            'title': ''
        }, popupOptions));
        var popupContainer = this.dialogSelector.dialog('widget').css('position', 'fixed');
        var treeSelectorContainer = $('<div class="popup-selector"></div>').appendTo(popupContainer.find('.ui-dialog-content'));
        
        var $body = $('body');
        this.dialogSelector.on( 'dialogopen', function() {
            $body.addClass('noscroll');
        }).on('dialogclose', function(){
            $body.removeClass('noscroll');
        });
        
        $(window).resize($.proxy(function() {
            this.dialogSelector.dialog('option', 'position', 'center');
        }, this));
        
        var opts = $.extend({
            reset: false // boolean or function that returns a boolean
        }, options);
        
        // Create the flat tree
        this.treeSelector = opts.createTree(treeSelectorContainer);
        
        var init = false;
        $(triggerSelector).click($.proxy(function() {
            this.dialogSelector.dialog('open');
            this.dialogSelector.dialog('widget').find('button.ui-dialog-titlebar-close').focusout();
            if(!init || (typeof opts.reset === 'function' ? opts.reset() : opts.reset)) {
                this.treeSelector.reset();
                this.treeSelector.init();
                init = true;
            }
        }, this));
       
    };
    
    return FlatTreePopup;
    
});
